import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
import {Link} from 'react-router-dom'
import {FormattedMessage, FormattedDate} from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import PaymentTermDueTypeLabel from './duetypelabel.component.jsx';
import DayOfMonthLabel from '../invoice/recurring/dayofmonthlabel.component.jsx';

class PaymentTermListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
            isProSubscriptionType: false,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshSearch()
    }


    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/payment-terms').then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.payment_term.list.headers.name_label"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="listing.payment_term.list.headers.type_label"
                defaultMessage="Type"
            />,
            <FormattedMessage
                id="listing.payment_term.list.headers.details_label"
                defaultMessage="Details"
            />,
            <FormattedMessage
                id="listing.payment_term.list.headers.action_label"
                defaultMessage="Action"
            />,
        ]
    }

    row(item) {
        let defaultBadge = null;
        if (item.attributes.isDefault) {
            defaultBadge =
                <FormattedMessage
                    id="payment_term.form.listing.default_label"
                    defaultMessage="Default"
                >
                    {(txt) => (
                        <span className="badge badge-info">
                            {txt}
                        </span>
                    )}
                </FormattedMessage>

        }
        let details = <FormattedMessage
            id="payment_term.label.details_fixed_days"
            defaultMessage="Due in {days} days"
            values={{
                days: item.attributes.dueInNumberOfDays
            }}
        />
        if (item.attributes.dueType === "day-of-month") {
            details = <FormattedMessage
                id="payment_term.label.details_days_of_month"
                defaultMessage="Due by the {day} of the month"
                values={{
                    day: <DayOfMonthLabel dayOfMonth={item.attributes.dueByDayOfMonth} />
                }}
            />
        }
        let defaultButton = <button onClick={this.setDefault(item.id)} className={'btn btn-sm btn-outline-primary'}>
            <FormattedMessage
                id="payment_term.form.listing.th.default_btn"
                defaultMessage="Set default"
            />
        </button>
        if (item.attributes.isDefault) {
            defaultButton = <button onClick={this.removeDefault(item.id)} className={'btn btn-sm btn-outline-primary'}>
                <FormattedMessage
                    id="payment_term.form.listing.th.remove_default_btn"
                    defaultMessage="Remove default"
                />
            </button>
        }
        return [
            <Link to={"/payment-terms/" + item.id + '/edit'}>{item.attributes.name}&nbsp;{defaultBadge}</Link>,
            <PaymentTermDueTypeLabel value={item.attributes.dueType} />,
            details,
            defaultButton,
        ]
    }

    setDefault(termId) {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().put('/payment-terms/' + termId + '/default').then(fee => {
                this.refreshSearch()
            })
        }.bind(this)
    }

    removeDefault(termId) {
        return function (e) {
            e.preventDefault()
            AppContext.getApiClient().patch('/payment-terms/' + termId, { isDefault: false }).then(fee => {
                this.refreshSearch()
            })
        }.bind(this)
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        return (
            <div>
                <MyAccountTabs/>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/payment-terms/new" className="btn btn-primary">
                                    <Icon value={"plus-circle"}/>
                                    <FormattedMessage
                                        id="payment_term.listing.add_payment_term_btn"
                                        defaultMessage="Add payment term"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default PaymentTermListing


// WEBPACK FOOTER //
// ./src/payment-term/listing.component.jsx